import React from "react";
import { Link, NavLink } from "react-router-dom";
const BeforeFooter = () => {
  return (
    <>
      <footer className="bg-light-theme pt-0 u-line bg-white">
        <div className="lg:px-2 px-4">
          <div className="container mx-auto">
            <div className="grid grid-cols-12 lg:gap-y-0 gap-y-6 py-12">
              <div className="lg:col-span-5 col-span-12">
                <div className="footer-contact lg:pe-6">
                  <div className="logo mainNavCol">
                    <Link to="/">
                      <img
                        src="/media/frontend/img/logo/new/line-logo1.png"
                        // src="/media/frontend/img/logo/new/logo.png"
                        className="w-[120px] img-fluid"
                        alt="Logo"
                      />
                    </Link>
                  </div>
                  <div className="lg:w-full md:w-2/3 w-full">
                    <p className="my-3">
                      Shefs Cloud works with a team of talented and passionate home shefs who combine taste, health, and quality to create mouthwatering meals for you. Every shef is carefully selected to ensure they meet our high standards for hygiene, skill, and dedication. From traditional home recipes to innovative dishes, our experts bring their culinary expertise to your plate.m of talented and passionate
                      home shefs who combine taste, health, and quality to
                      create mouthwatering meals for you. Every shef is
                      carefully selected to make sure he or she meets our high
                      standards for hygiene, skill, and dedication. From
                      traditional home recipes to innovative dishes, our experts
                      bring their culinary expertise to your plate.
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-7 col-span-12">
                <div className="grid grid-cols-12 lg:gap-y-0 gap-y-6 pt-6">
                  <div className="md:col-span-4 col-span-12">
                    <div className="footer-links">
                      <h6 className="">Get to Know Us</h6>
                      <ul>
                        <li>
                          <Link to="/about" className="text-light-white fs-14">
                            About Us
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/terms-of-services "
                            className="text-light-white fs-14"
                          >
                            Terms of Servies
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/privacy-policy"
                            className="text-light-white fs-14"
                          >
                            Privacy Policy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-12">
                    <div className="footer-links">
                      <h6 className="">Doing Business</h6>
                      <ul>
                        <li>
                          <Link
                            to="/become-a-chef"
                            className="text-light-white fs-14"
                          >
                            Become a Shef
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/homemade-food-delivery"
                            className="text-light-white fs-14"
                          >
                            Home food Delivery
                          </Link>
                        </li>
                        <li>
                          <Link to="/faqs" className="text-light-white fs-14">
                            Faqs
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="md:col-span-4 col-span-12">
                    <div className="footer-links">
                      <h6 className="">Customer Support</h6>
                      <ul>
                        <li>
                          <Link
                            to="tel:+920000000000"
                            rel="noopener"
                            className="text-light-white fs-14 flex items-center gap-x-2"
                          >
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="14"
                                height="14"
                                fill="rgba(0,0,0,1)"
                              >
                                <path d="M21 16.42V19.9561C21 20.4811 20.5941 20.9167 20.0705 20.9537C19.6331 20.9846 19.2763 21 19 21C10.1634 21 3 13.8366 3 5C3 4.72371 3.01545 4.36687 3.04635 3.9295C3.08337 3.40588 3.51894 3 4.04386 3H7.5801C7.83678 3 8.05176 3.19442 8.07753 3.4498C8.10067 3.67907 8.12218 3.86314 8.14207 4.00202C8.34435 5.41472 8.75753 6.75936 9.3487 8.00303C9.44359 8.20265 9.38171 8.44159 9.20185 8.57006L7.04355 10.1118C8.35752 13.1811 10.8189 15.6425 13.8882 16.9565L15.4271 14.8019C15.5572 14.6199 15.799 14.5573 16.001 14.6532C17.2446 15.2439 18.5891 15.6566 20.0016 15.8584C20.1396 15.8782 20.3225 15.8995 20.5502 15.9225C20.8056 15.9483 21 16.1633 21 16.42Z"></path>
                              </svg>
                            </span>
                            <span>+92 320 2024035</span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="mailto:info@shefscloud.com"
                            className="text-light-white fs-14 flex items-center gap-x-2"
                          >
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="14"
                                height="14"
                                fill="rgba(0,0,0,1)"
                              >
                                <path d="M2 5.5V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V19H20V7.3L12 14.5L2 5.5ZM0 10H5V12H0V10ZM0 15H8V17H0V15Z"></path>
                              </svg>
                            </span>
                            <span>info@shefscloud.com</span>
                          </Link>
                        </li>
                        <li>
                          <div className="ft-social-media mt-3">
                            <ul className="flex gap-x-4">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="32" height="32" fill="none">
  <circle cx="128" cy="128" r="128" fill="#25D366" />
  <path
    d="M128 37.25c-49.92 0-90.75 40.84-90.75 90.75 0 16.25 4.35 32.08 12.58 45.79L37.25 218l44.47-12.34c13.17 7.8 28.36 12.34 46.28 12.34 49.92 0 90.75-40.84 90.75-90.75S177.92 37.25 128 37.25ZM128 197c-14.92 0-28.75-3.99-40.7-11.34l-2.89-1.77-26.41 7.31 7.06-25.58-1.82-2.92C53.07 150.4 49.25 139.5 49.25 128c0-43.56 35.19-78.75 78.75-78.75s78.75 35.19 78.75 78.75-35.19 78.75-78.75 78.75Zm45.77-60.74c-2.51-1.25-14.84-7.35-17.14-8.19-2.29-.83-3.97-1.25-5.65 1.25-1.66 2.5-6.49 8.18-7.97 9.86-1.49 1.66-2.91 1.87-5.42.62-2.51-1.25-10.6-3.89-20.18-12.39-7.45-6.64-12.45-14.84-13.91-17.35-1.45-2.5-.16-3.86 1.09-5.12 1.12-1.13 2.49-2.93 3.73-4.4 1.25-1.46 1.66-2.49 2.49-4.15.83-1.66.42-3.12-.21-4.37-.62-1.25-5.41-13.46-7.41-18.66-1.97-5.26-3.98-4.54-5.65-4.63-1.46-.08-3.12-.08-4.78-.08-1.66 0-4.37.62-6.67 3.12-2.29 2.5-8.71 8.51-8.71 20.77 0 12.25 8.93 24.08 10.18 25.74 1.25 1.66 17.57 27.2 42.92 37.99 25.32 10.8 25.32 7.2 29.8 6.72 4.45-.5 14.49-5.88 16.54-11.54 2.08-5.66 2.08-10.5 1.46-11.54-.62-1.04-2.29-1.66-4.8-2.91Z"
    fill="#fff"
  />
</svg>



<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="32" height="32" fill="none">
  <circle cx="128" cy="128" r="128" fill="#1877F2" />
  <path
    d="M154.36 102.4h-18.8v-10.54c0-4.47 2.93-5.53 4.85-5.53h13.96V70.07l-19.18-.02c-10.2 0-17.06 6.95-17.06 17.45v12.9h-11.68v15.2h11.68v44.56h19.1v-44.56h13.47l2.16-15.2Z"
    fill="#fff"
  />
</svg>
</ul>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="hidden">
                <div className="footer-contact">
                  <h6 className="">Newsletter</h6>
                  <form className="subscribe_form">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control form-control-submit"
                        name="email"
                        placeholder="Enter your email"
                      />
                      <span className="input-group-btn">
                        <button
                          className="btn btn-second btn-submit"
                          type="button"
                        >
                          <i className="fas fa-paper-plane"></i>
                        </button>
                      </span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright lg:!px-2 !px-4 md:py-3 py-1">
        <div className="container mx-auto">
          <div className="grid grid-cols-12 gag-2">
            <div className="md:col-span-6 col-span-12">
              <div className="md:flex gap-x-6 md:justify-start justify-center items-center">
                <div className="flex gap-x-4 lg:justify-start justify-center md:mt-0 mt-3">
                </div>
              </div>
            </div>
            <div className="md:col-span-6 col-span-12 md:text-end text-center md:mt-0 mt-2">
              <div className="text-light-white fs-14">
                Shefs Cloud 2026. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeforeFooter;
